import React from 'react';
const steps = [{
  num: '1',
  text: 'Elegís uno de los menús inteligentes.'
}, {
  num: '2',
  text: 'Descargás tu lista automática de compras.'
}, {
  num: '3',
  text: 'Comprás todo en 15 minutos.'
}, {
  num: '4',
  text: 'Cocinás 2 horas siguiendo el orden estratégico.'
}, {
  num: '5',
  text: 'Congelás correctamente.'
}, {
  num: '6',
  text: 'Durante 15 días solo descongelás y comés.'
}];
export function HowItWorks() {
  return <section className="py-5 md:py-7 px-4 bg-[#F7F5F0] text-text-primary" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight" data-id="element-123">
          Así funciona el Sistema 15D
        </h2>

        <div className="space-y-2 md:space-y-3 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-px before:bg-black/10" data-id="element-124">
          {steps.map((step, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group" data-id="element-125">
              <div className="flex items-center justify-center w-7 h-7 md:w-9 md:h-9 border-2 border-[#F7F5F0] bg-primary text-white font-bold text-sm md:text-base shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10 rounded-full" data-id="element-126">
                {step.num}
              </div>
              <div className="w-[calc(100%-3rem)] md:w-[calc(50%-2.5rem)] p-2.5 md:p-4 bg-white border border-black/5 rounded-2xl shadow-sm" data-id="element-127">
                <p className="text-xs md:text-sm font-medium text-text-secondary" data-id="element-128">
                  <span className="font-bold text-primary mr-1 md:mr-2 uppercase tracking-wide text-[10px] md:text-xs" data-id="element-129">
                    Paso {step.num} —
                  </span>
                  {step.text}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-5 md:mt-7 text-center space-y-1 text-xs md:text-base font-bold text-primary" data-id="element-130">
          <p data-id="element-131">Sin improvisar.</p>
          <p data-id="element-132">Sin repetir siempre lo mismo.</p>
          <p data-id="element-133">Sin cocinar todos los días.</p>
        </div>
      </div>
    </section>;
}